const STORAGE_KEY = 'eiendomsverdi_dismissed_priority';

export const initPriorityMessagesController = () => {
  const container = document.getElementById('PriorityMessages');
  if (!container) return;

  const items = [...container.querySelectorAll('[data-priority-id]')];
  const dismissed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  const active = items.filter(el => !dismissed.includes(Number(el.dataset.priorityId)));

  if (active.length === 0) return;

  container.removeAttribute('hidden');
  showMessage(container, active, 0);
  updateHeight();

  window.addEventListener('resize', () => window.throttle('resizePriority', updateHeight, 500));
}

const showMessage = (container, active, index) => {
  const current = active[index];
  const count = active.length - index;

  current.classList.remove('hidden');

  const countEl = container.querySelector('[data-priority-count]');
  if (count > 1 && countEl) {
    countEl.textContent = `1 av ${count}`;
    countEl.classList.remove('hidden');
  } else if (countEl) {
    countEl.classList.add('hidden');
  }

  container.querySelector('[data-priority-dismiss]').addEventListener('click', () => {
    const dismissed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    dismissed.push(Number(current.dataset.priorityId));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissed));

    current.classList.add('hidden');

    if (index + 1 >= active.length) {
      container.setAttribute('hidden', '');
    } else {
      showMessage(container, active, index + 1);
    }

    updateHeight();
  }, { once: true });
}

const updateHeight = () => {
  const wrapper = document.getElementById('Notifications');
  if (wrapper) {
    document.documentElement.style.setProperty('--notifications-height', `${wrapper.offsetHeight}px`);
  }
}
